import React from 'react'
import Layout from '../../../components/help/Layout/Layout'
import Seo from '../../../components/help/Seo'
import Header from '../../../components/ui/Header/Header'
import Intro from '../../../components/ui/Intro/Intro'
import { getHrefToHome } from '../../../utils/getHrefToHome'
import { graphql, useStaticQuery } from 'gatsby'
import CorporateGovernance from '../../../components/pages/CorporateGovernance/CorporateGovernance'

const CorporateGovernancePage = () => {
    const lang = 'en'
    const hrefHome = getHrefToHome(lang)

    const data = useStaticQuery(graphql`
        {
            title: datoCmsRenshinPageCorporateGovernance(title: { eq: "Title" }, locale: { eq: "en" }) {
                value
            }

            text: datoCmsRenshinPageCorporateGovernance(title: { eq: "Text" }, locale: { eq: "en" }) {
                value
            }

            items: allDatoCmsRenshinCorporateGovernanceSection(sort: { fields: sorting, order: ASC }, filter: { locale: { eq: "en" } }) {
                nodes {
                    id
                    title
                }
            }

            files: allDatoCmsRenshinCorporateGovernanceFile(filter: { locale: { eq: "en" } }) {
                nodes {
                    name
                    section {
                        id
                    }
                    file {
                        url
                        size
                        mimeType
                    }
                }
            }

            seo: datoCmsRenshinSeo(pageName: { eq: "Corporate governance" }, locale: { eq: "en" }) {
                titleH1
                crumbsName
                bgDesktop {
                    url
                }
                bgTabletA {
                    url
                }
                bgTabletP {
                    url
                }

                bgMobile {
                    url
                }
                footerLinks {
                    title
                    url
                }
                seo {
                    title
                    description
                }
            }

            main: datoCmsRenshinSeo(pageName: { eq: "Main" }, locale: { eq: "en" }) {
                crumbsName
            }
        }
    `)

    const breadCrumbs = [
        { name: `${data.main.crumbsName}`, href: `${hrefHome}`, current: false },
        { name: `${data.seo.crumbsName}`, current: true }
    ]

    const photo = {
        1920: data.seo.bgDesktop?.url,
        1440: data.seo.bgDesktop?.url,
        1024: data.seo.bgTabletA?.url,
        768: data.seo.bgTabletP?.url,
        360: data.seo.bgMobile?.url
    }

    return (
        <Layout lang={lang}>
            <Seo
                title={data.seo.seo && data.seo.seo.title ? data.seo.seo.title : ''}
                description={data.seo.seo && data.seo.seo.description ? data.seo.seo.description : ''}
            />

            <Header light lang={lang} />
            <Intro crumbs={breadCrumbs} title={data.seo.titleH1} photo={photo} lang={lang} />

            <CorporateGovernance data={data} lang={lang} />
        </Layout>
    )
}

export default CorporateGovernancePage
